export default __webpack_public_path__ + "static/settingwall-5c4ee7c5252f1ba6cb4fe351c1afa0fd.png";